export default {"src":"/_next/static/media/op-mainnet.4363bdf9.svg","height":41,"width":41,"blurWidth":0,"blurHeight":0};